import { useEffect, useState } from "react";

// STYLES
import * as Style from "./AddNewLockerStyle";

// LIBRARIES
import { useTranslation } from "react-i18next";

// MISC
import { COLORS } from "constants/styleVariables";
import {
  ButtonTypes, InputTypes
} from "models/GeneralTypes/generalTypes";
import { IProps } from "./AddNewLockerModel";
import EditIconHovered from "assets/Icons/HistoryIconHovered.svg";

// ASSETS

// REDUX
import ButtonAtom from "components/Atoms/ButtonAtom/ButtonAtom";
import InputAtom from "components/Atoms/InputAtom/InputAtom";
import { createLocker, getAllLockers } from "api/lockerApi";
import { useAppDispatch } from "hooks/reduxHooks";
import { toggleModalState } from "slices/uiSlice";

// COMPONENTS

const AddNewLocker = (props: IProps) => {
  // PROPS
  const { handleClose = () => { } } = props;

  // CONSTANTS USING LIBRARIES
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  // CONSTANTS USING HOOKS
  const [value, setValue] = useState<string>("");
  const [secondValue, setSecondValue] = useState<string>("");
  const [checkboxValue, setCheckboxValue] = useState();

  // GENERAL CONSTANTS

  // USE EFFECT FUNCTION
  useEffect(() => {
  }, []);

  // REQUEST API FUNCTIONS

  // HANDLERS FUNCTIONS
  const toggleSelectedCheckbox = (value) => {
    setCheckboxValue(value);
  }

  const handleSaveLocker = () => {
    let lockerDetails = {
      name: value,
      address: secondValue,
    };
    dispatch(createLocker(lockerDetails))
      .unwrap()
      .then(() => {
        dispatch(getAllLockers())
          .then(() => {
            dispatch(
              toggleModalState({
                isVisible: false,
                type: "",
              })
            );
          })
      })
      .catch((error) => {
        console.log(error);
      });

  }

  return (
    <Style.ModalContainer>
      <Style.CloseIconContainer>
        <Style.CloseIcon onClick={handleClose} />
      </Style.CloseIconContainer>
      <Style.HeaderWrapper>
        <Style.IconContainer>
          <Style.HeaderIcon
            src={EditIconHovered}

          >
          </Style.HeaderIcon>
        </Style.IconContainer>
        <Style.ContentInfo>
          <Style.HeaderTitle>
            {t("modal.addNewLocker.title")}
          </Style.HeaderTitle>
          <Style.HeaderSubtitle>
            {t("modal.addNewLocker.title")}
          </Style.HeaderSubtitle>
        </Style.ContentInfo>
      </Style.HeaderWrapper>
      <Style.SearchWrapper>
        <Style.Subtitle>
          {t("modal.addNewLocker.lockerDetails")}
        </Style.Subtitle>
        <Style.InputAtomContainer>
          <InputAtom
            placeholder={"Scrie..."}
            label={t("modal.addNewLocker.lockerName")}
            inputValue={value}
            setInputValue={(value) =>
              setValue(value)
            }
            type={InputTypes.MODAL_INPUT}
          />
        </Style.InputAtomContainer>
        <Style.InputAtomContainer>
          <InputAtom
            placeholder={"Scrie..."}
            label={t("modal.addNewLocker.lockerAdress")}
            inputValue={secondValue}
            setInputValue={(secondValue) =>
              setSecondValue(secondValue)
            }
            type={InputTypes.MODAL_INPUT}
          />
        </Style.InputAtomContainer>
        <Style.Subtitle>
          {t("modal.addNewLocker.lockerSize")}
        </Style.Subtitle>
        <Style.CheckboxLine onClick={() => { toggleSelectedCheckbox("8") }}>
          <Style.CheckBox isSelected={checkboxValue === "8"} />
          <Style.Value>
            {`8 ${t("modal.addNewLocker.doors")}`}
          </Style.Value>
        </Style.CheckboxLine>
        <Style.CheckboxLine onClick={() => { toggleSelectedCheckbox("16") }}>
          <Style.CheckBox isSelected={checkboxValue === "16"} />
          <Style.Value>
            {`16 ${t("modal.addNewLocker.doors")}`}
          </Style.Value>
        </Style.CheckboxLine>
      </Style.SearchWrapper>
      <Style.ButtonContainer>
        <ButtonAtom
          text={t("modal.addNewLocker.save")}
          type={ButtonTypes.MAIN_BUTTON}
          onClick={() => handleSaveLocker()}
          width="169px"
        />
      </Style.ButtonContainer>
    </Style.ModalContainer>
  );
};

export default AddNewLocker;
